import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'focus-visible';
import '../sections/header';
import '../sections/footer';
import '../sections/multi-column-tiles';
import '../sections/text-block';
import '../sections/trigger-buttons';
import '../sections/email-popup';
import '../sections/video-lightbox';
import '../sections/fifty-fifty-slider';
import '../sections/multi-column-carousel';
import '../sections/transparent-header';
import '../sections/notification-bar';
import '../sections/comparison-carousel';
import '../sections/phase-tabs';
import '../sections/product-carousel';
import '../sections/product-grid';
import '../sections/ritual-section';
import '../../styles/theme.scss';
import '../components/live-search';
import '../components/live-search-burger';
import '../components/Fields/floating-labels';
import '../components/BackInStock/back-in-stock';
import '../components/unmute-video';
import '../components/side-cart';
import { bindInPageLinks, focusHash } from '@shopify/theme-a11y';
import DoctorCodeURL from '../components/Checkout/CheckoutDoctorCodeURL';
import Loader from '../components/Loader/loading';
import RegionSelector from '../components/region-selector';
import UKPopup from '../components/UKPopup/uk-popup';
import { docReady } from '../utils/docReady';
import eGiftCards from '../components/eGiftCards/eGiftCards';
import '../components/Product/add-to-cart-button';
import initCountdown from '../sections/countdown-banner';
import RegionAutomaticRedirection from '../components/RegionDetection/region-automatic-redirection';
import ProtectedPages from '../components/ProtectedPages/protected-pages';
import StickyBar from '../components/sticky-bar';
import SideCart from '../components/side-cart';
import Recommendations from '../components/recommendations';
docReady(() => {
    focusHash({
        className: null,
        ignore: null,
    });
    bindInPageLinks({
        className: null,
        ignore: null,
    });
    UKPopup();
    DoctorCodeURL.init();
    Loader.init();
    RegionSelector();
    eGiftCards.init();
    initCountdown();
    ProtectedPages();
    // Apply a specific class to the html element for browser support of cookies.
    if (window.navigator.cookieEnabled) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }
    Loader.show();
    window.addEventListener('load', () => {
        if (window.theme.automaticalRedirectionEnabled || window.theme.showPopupRedirectionEnabled) {
            RegionAutomaticRedirection();
        }
        else {
            window.dispatchEvent(new CustomEvent('ready-to-display-newsletter'));
        }
        Loader.hide();
        document.body.classList.remove('loading');
    });
    setTimeout(() => {
        Loader.hide();
        document.body.classList.remove('loading');
    }, 1500);
    const links = document.getElementsByTagName('a');
    [...links].forEach((link) => {
        const href = link.getAttribute('href');
        const target = link.getAttribute('target');
        if (href) {
            if (!href.includes('javascript') && href.charAt(0) !== '#' && target !== '_blank' && !link.classList.contains('burger-menu__link')) {
                link.addEventListener('click', () => {
                    document.body.classList.add('loading');
                });
            }
        }
    });
    const addressDeleteForm = document.querySelector('form[data-address-delete-form]');
    const acceptsMarketing = document.querySelector('input[name="accepts_marketing"]');
    if (addressDeleteForm) {
        addressDeleteForm.addEventListener('submit', () => {
            document.body.classList.add('loading');
        });
    }
    if (acceptsMarketing) {
        acceptsMarketing.addEventListener('change', () => {
            document.body.classList.add('loading');
        });
    }
    //Use the cookie consent in local storage to set the initial value as soon as the page is ready
    if (localStorage.getItem('cookie-consent') === 'allow') {
        window.__rmcp2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    }
    else {
        window.__rmcp2 = [];
    }
    const cookieConsentLoaded = setInterval(() => {
        if (window.pandectesCookieConsent) {
            clearInterval(cookieConsentLoaded);
            const pandectesGdprCookie = window.pandectesCookieConsent.utils.getCookie('_pandectes_gdpr');
            //Validate the saved cookie statu to update the window variable and local storage.
            if (pandectesGdprCookie.status === 'allow') {
                window.__rmcp2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                localStorage.setItem('cookie-consent', 'allow');
            }
            else {
                window.__rmcp2 = [];
                localStorage.setItem('cookie-consent', 'deny');
            }
            const hasInitialized = setInterval(() => {
                if (window.pandectesCookieConsent.hasInitialised === true) {
                    clearInterval(hasInitialized);
                    document.addEventListener('click', (e) => {
                        if (e.target.classList.contains('cc-allow')) {
                            window.__rmcp2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                            localStorage.setItem('cookie-consent', 'allow');
                        }
                    });
                    document.addEventListener('click', (e) => {
                        if (e.target.classList.contains('cc-deny')) {
                            window.__rmcp2 = [];
                            localStorage.setItem('cookie-consent', 'deny');
                        }
                    });
                }
            }, 100);
        }
    }, 300);
    let stickyBar = document.querySelector('.sticky-bar__container');
    let sections = document.querySelectorAll('main .shopify-section');
    debugger;
    if (!!stickyBar && !!sections[1]) {
        sections[1].parentNode.insertBefore(stickyBar, sections[1]);
        ReactDOM.render(React.createElement(StickyBar), stickyBar);
    }
    let collapsibleTabs = document.querySelectorAll('.accordion');
    if (collapsibleTabs) {
        collapsibleTabs.forEach((collapsibleTab) => {
            let tabTitle = collapsibleTab.querySelector('.accordion-tab');
            if (!tabTitle)
                return;
            collapsibleTab.style.setProperty('--tab-height', `${tabTitle.scrollHeight}px`);
            collapsibleTab.addEventListener('click', () => {
                collapsibleTab.classList.toggle('accordion--active');
            });
        });
    }
});
let listenerEnabled = false;
let questionButton = document.querySelector('.question');
if (questionButton) {
    questionButton.addEventListener('click', () => {
        let questionOptions = document.querySelector('.question-options');
        questionOptions.classList.toggle('question-options--visible');
        questionButton.classList.toggle('question--active');
    });
    document.addEventListener('click', (e) => {
        if (e.target.closest('.question'))
            return;
        let questionOptions = document.querySelector('.question-options');
        questionOptions.classList.remove('question-options--visible');
        questionButton.classList.remove('question--active');
    });
}
let clinicianButton = document.querySelector('.question-option--clinician');
if (clinicianButton) {
    clinicianButton.addEventListener('click', () => {
        let chatWidgetContainer = document.querySelector('#chat-widget-container');
        if (chatWidgetContainer)
            chatWidgetContainer.classList.add('chat-widget-container--visible');
        // @ts-ignore
        LiveChatWidget.call('maximize');
        if (listenerEnabled)
            return;
        // @ts-ignore
        LiveChatWidget.on('visibility_changed', onVisibilityChanged);
        listenerEnabled = true;
    });
}
const onVisibilityChanged = (visibilityState) => {
    // @ts-ignore
    if (visibilityState.visibility == 'minimized') {
        let chatWidgetContainer = document.querySelector('#chat-widget-container');
        if (chatWidgetContainer)
            chatWidgetContainer.classList.remove('chat-widget-container--visible');
    }
};
setTimeout(() => {
    // @ts-ignore
    if (!window.LiveChatWidget)
        return;
    // @ts-ignore
    window.LiveChatWidget.on('visibility_changed', onVisibilityChanged);
    listenerEnabled = true;
}, 100);
const animationDuration = 2000;
const frameDuration = 1000 / 60;
const totalFrames = Math.round(animationDuration / frameDuration);
const easeOutQuad = t => t * (2 - t);
const triggerCounter = (accordion) => {
    let content = accordion.innerText;
    let number = parseInt(content.match(/\d+/g)[0]);
    accordion.style.setProperty('--counter-end', number);
    let frame = 0;
    let interval = setInterval(function () {
        frame++;
        const progress = easeOutQuad(frame / totalFrames);
        // Use the progress value to calculate the current count
        const currentCount = Math.round(number * progress);
        accordion.innerText = content.replace(/\d+/g, currentCount.toString());
        if (frame == totalFrames) {
            clearInterval(interval);
            return;
        }
    }, frameDuration);
};
const checkAccordionVisibility = () => {
    let accordions = document.querySelectorAll('.fifty-fifty-block__info-row__title');
    accordions.forEach((accordion) => {
        if (!accordion)
            return;
        // check if the element is in viewport
        let rect = accordion.getBoundingClientRect();
        let elemTop = rect.top;
        let elemBottom = rect.bottom;
        let isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
        if (isVisible && !accordion.classList.contains('fifty-fifty-block__info-row__title--visible')) {
            accordion.classList.add('fifty-fifty-block__info-row__title--visible');
            triggerCounter(accordion);
        }
    });
};
document.addEventListener('scroll', (e) => {
    checkAccordionVisibility();
});
checkAccordionVisibility();
function interceptClickEvent(e) {
    var href;
    var target = e.target || e.srcElement;
    let parentAnchor = target.closest('a');
    if (target.tagName === 'A' || parentAnchor) {
        href = target.getAttribute('href') || parentAnchor.getAttribute('href');
        if (href.indexOf('/products') > -1) {
            window.location.href = `${href}?quizId=${window.quizId}&quizKey=${window.quizKey}`;
            e.preventDefault();
        }
    }
}
if (window.quizId) {
    if (document.addEventListener) {
        document.addEventListener('click', interceptClickEvent);
    }
}
let links = document.querySelectorAll('.footer__link-item a');
links.forEach((link) => {
    if (link.hostname !== window.location.hostname) {
        link.target = '_blank';
        link.rel = 'noreferrer noopener';
    }
});
docReady(() => {
    let blankElements = document.querySelectorAll('a[target="_blank"]');
    blankElements.forEach((element) => {
        let ariaLabel = element.getAttribute('aria-label');
        console.log(ariaLabel);
        if (!!ariaLabel)
            return;
        let label = element.innerText;
        if (!label) {
            label = element.href;
        }
        element.setAttribute('aria-label', `${label} (opens in a new tab)`);
    });
});
const hero = document.querySelector('.full-width-video-image--logo');
const bodyElement = document.querySelector('body');
if (hero && bodyElement.classList.contains('transparent-default')) {
    const headerLogo = document.querySelector('.header__logo');
    const heroLogos = hero.querySelectorAll('.full-width-video-image__logo');
    bodyElement.classList.add('header-style--transparent');
    document.addEventListener('scroll', () => {
        heroLogos.forEach((heroLogo) => {
            if (window.getComputedStyle(heroLogo).display === 'none')
                return;
            if (heroLogo.getBoundingClientRect().top < 0) {
                headerLogo.classList.add('header__logo--active');
                heroLogo.classList.add('full-width-video-image__logo--hidden');
                bodyElement.classList.add('header-style--hero-scrolled');
            }
            else {
                headerLogo.classList.remove('header__logo--active');
                heroLogo.classList.remove('full-width-video-image__logo--hidden');
                bodyElement.classList.remove('header-style--hero-scrolled');
            }
        });
    });
}
const sidecart = document.querySelector('.sidecart-wrapper');
if (sidecart) {
    const sidecartJSON = sidecart.querySelector('script[type="application/json"]');
    const sidecartData = JSON.parse(sidecartJSON.innerHTML);
    ReactDOM.render(React.createElement(SideCart, sidecartData), sidecart);
}
let recommendations = document.querySelectorAll('.product-upsells');
if (!!recommendations) {
    recommendations.forEach((recommendations) => {
        let recommendationsJSON = recommendations.querySelector('script[type="application/json"]');
        let recommendationsData = JSON.parse(recommendationsJSON.innerHTML);
        console.log('recommendationsData', recommendationsData, recommendationsData.parentClass);
        ReactDOM.render(React.createElement(Recommendations, recommendationsData), recommendations);
    });
}
